import { useRubyContent } from "~/hooks/useRubyContent";
import { cn } from "~/lib/utils";

export function Furigana({
  children,
  className,
  rubyContent,
  highlightWord,
}: {
  children?: React.ReactNode;
  className?: string;
  rubyContent?: string;
  highlightWord?: string;
}) {
  const parsedContent = useRubyContent(rubyContent, highlightWord);

  return (
    <span
      className={cn("inline-block whitespace-pre-wrap break-words", className)}
    >
      {parsedContent ?? children}
    </span>
  );
}
